var chunkToChildrenMap = {
	"src_wl-startup_client_routes_js": [
		"src_assets_lego-ssl-logo_svg",
		"src_wl-web_ui_pages_signup_Lego_LegoChildSimpleSignup_tsx"
	],
	"src_wl-startup_client_LegoRoutes_tsx": [
		"src_wl-web_ui_pages_lego_AccountSwitcher_GuardianAccountSettings_tsx",
		"src_wl-web_ui_pages_lego_AccountSwitcher_ChildPermissions_tsx",
		"src_wl-web_ui_pages_lego_AccountSwitcher_AccountSwitcher_tsx",
		"vendors-node_modules_pnpm_lodash_4_17_21_node_modules_lodash_curry_js",
		"src_wl-web_ui_pages_CoursePage_tsx",
		"src_assets_lego-ssl-logo_svg",
		"src_wl-web_ui_pages_signup_Lego_LegoSignup_tsx",
		"src_wl-web_ui_pages_signup_Lego_LegoChildSimpleSignup_tsx",
		"src_wl-web_ui_pages_login_Lego_LegoLogin_tsx",
		"src_wl-web_ui_pages_landingPage_Lego_LegoLandingPage_tsx",
		"src_wl-web_ui_pages_lego_AccountDashboard_AccountDashboard_tsx",
		"src_wl-web_ui_pages_lego_CreationPage_tsx",
		"src_wl-web_ui_components_verify_Lego_LegoEmailVerificationConfirmation_tsx",
		"src_wl-web_ui_pages_MyQuestsPage_tsx",
		"src_wl-web_ui_components_verify_Lego_LegoEmailVerificationWall_tsx"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };